import { ActionTypes } from '../actions/types';
import { LademittelModel } from '../../models/LademittelModel';
import { VerpackungModel } from '../../models/VerpackungModel';
import { EigentuemerModel } from '../../models/EigentuemerModel';
import { WaehrungModel } from '../../models/WaehrungModel';
import { TerminkennzeichenModel } from '../../models/TerminkennzeichenModel';
import { ZustellkennzeichenModel } from '../../models/ZustellkennzeichenModel';
import { AnlieferkennzeichenModel } from '../../models/AnlieferkennzeichenModel';
import { ReportModel } from '../../models/ReportModel';
import { FrankaturModel } from '../../models/FrankaturModel';
import { VerkehrsartModel } from '../../models/VerkehrsartModel';
import { LandModel } from '../../models/LandModel';
import { Sprache } from '../../api';
import { MetrokennungModel } from '../../models/MetrokennungModel';
import { SperrigkeitModel } from '../../models/SperrigkeitModel';
import { StatusModel } from '../../models/StatusModel';
import { AuftragServiceModel } from '../../models/AuftragServiceModel';

const initialState = {
  lademittel: [],
  verpackungen: [],
  eigentuemer: [],
  waehrungen: [],
  terminkennzeichen: [],
  zustellkennzeichen: [],
  anlieferkennzeichen: [],
  laender: [],
  suchvorschlaege: [],
  reports: [],
  frankaturen: [],
  verkehrsarten: [],
  metrokennungen: [],
  sperrigkeiten: [],
  sprachen: [],
  mandanten: [],
  stati: [],
  dynamicServices: [], //#84367
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_LADEMITTEL: {
      const lademittel = payload.map((lademittel: LademittelModel) => {
        return {
          ...lademittel,
        };
      });
      return {
        ...state,
        lademittel: lademittel,
      };
    }
    case ActionTypes.GET_VERPACKUNGEN: {
      const verpackungen = payload.map((verpackungen: VerpackungModel) => {
        return {
          ...verpackungen,
        };
      });
      return {
        ...state,
        verpackungen: verpackungen,
      };
    }
    case ActionTypes.GET_REPORTS: {
      const reports = payload.map((report: ReportModel) => {
        return {
          ...report,
        };
      });
      return {
        ...state,
        reports: reports,
      };
    }
    case ActionTypes.GET_DYNAMIC_AUFTRAG_SERVICES: {
      //#84367
      const auftragServices = payload.map(
        (auftragService: AuftragServiceModel) => {
          return {
            ...auftragService,
          };
        }
      );
      return {
        ...state,
        dynamicServices: auftragServices,
      };
    }

    case ActionTypes.GET_ALL_STATI: {
      const statis = payload.map((stati: StatusModel) => {
        return {
          ...stati,
        };
      });
      return {
        ...state,
        stati: statis,
      };
    }
    case ActionTypes.GET_SPRACHEN: {
      const sprachen = payload.map((sprachen: Sprache) => {
        return {
          ...sprachen,
        };
      });
      return {
        ...state,
        sprachen: sprachen,
      };
    }
    case ActionTypes.GET_EIGENTUEMER: {
      const eigentuemer = payload.map((eigentuemer: EigentuemerModel) => {
        return {
          ...eigentuemer,
        };
      });
      return {
        ...state,
        eigentuemer: eigentuemer,
      };
    }
    case ActionTypes.GET_WAEHRUNGEN: {
      const waehrungen = payload.map((waehrungen: WaehrungModel) => {
        return {
          ...waehrungen,
        };
      });
      return {
        ...state,
        waehrungen: waehrungen,
      };
    }
    case ActionTypes.SEARCH_ORTE:
      return {
        ...state,
        suchvorschlaege: payload,
      };
    case ActionTypes.GET_TERMINKENNZEICHEN: {
      const terminkennzeichen: TerminkennzeichenModel[] = payload.map(
        (terminkennzeichen: TerminkennzeichenModel) => {
          return {
            ...terminkennzeichen,
          };
        }
      );

      return {
        ...state,
        terminkennzeichen: terminkennzeichen,
      };
    }
    case ActionTypes.GET_ZUSTELLKENNZEICHEN: {
      const zustellkennzeichen = payload
        .sort((a: any, b: any) =>
          a.kurzBezeichnung > b.kurzBezeichnung ? 1 : -1
        )
        .map((zustellkennzeichen: ZustellkennzeichenModel) => {
          return {
            ...zustellkennzeichen,
          };
        });

      return {
        ...state,
        zustellkennzeichen: zustellkennzeichen,
      };
    }
    case ActionTypes.GET_ANLIEFERKENNZEICHEN: {
      const anlieferkennzeichen = payload.map(
        (anlieferkennzeichen: AnlieferkennzeichenModel) => {
          return {
            ...anlieferkennzeichen,
          };
        }
      );

      return {
        ...state,
        anlieferkennzeichen: anlieferkennzeichen,
      };
    }
    case ActionTypes.GET_FRANKATUREN: {
      const frankaturen = payload.map((frankaturen: FrankaturModel) => {
        return {
          ...frankaturen,
        };
      });

      return {
        ...state,
        frankaturen: frankaturen,
      };
    }
    case ActionTypes.GET_VERKEHRSARTEN: {
      const verkehrsarten = payload.map((verkehrsarten: VerkehrsartModel) => {
        return {
          ...verkehrsarten,
        };
      });

      return {
        ...state,
        verkehrsarten: verkehrsarten,
      };
    }
    case ActionTypes.GET_METROKENNUNGEN: {
      const metrokennungen = payload.map(
        (metrokennungen: MetrokennungModel) => {
          return {
            ...metrokennungen,
          };
        }
      );
      return {
        ...state,
        metrokennungen: metrokennungen,
      };
    }

    case ActionTypes.GET_SPERRIGKEITEN: {
      const sperrigkeiten = payload.map((sperrigkeiten: SperrigkeitModel) => {
        return {
          ...sperrigkeiten,
        };
      });

      return {
        ...state,
        sperrigkeiten: sperrigkeiten,
      };
    }

    case ActionTypes.GET_LAENDER: {
      payload.sort((a: LandModel, b: LandModel) => {
        const textA = a.lkz.toUpperCase();
        const textB = b.lkz.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      return {
        ...state,
        laender: payload,
      };
    }
    case ActionTypes.GET_DEFAULTSTATUSKETTE: {
      return {
        ...state,
        defaultstatuskette: payload,
      };
    }
    case ActionTypes.SET_DEFAULTSTATUSKETTE: {
      return {
        ...state,
        defaultstatuskette: payload,
      };
    }
    case ActionTypes.CLEAR_SUCHVORSCHLAEGE:
      return {
        ...state,
        suchvorschlaege: [],
      };
    case ActionTypes.GET_MANDANTEN_BY_HAUPTMANDANT:
      return {
        ...state,
        mandanten: payload,
      };

    default:
      return state;
  }
}
